import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.activeDashboard && _vm.activeDashboard.id !== null ? _c('div', [_c('dashboard-toolbar', {
    attrs: {
      "dashboard-layers": _vm.dashboardLayers,
      "date-range": _vm.actualDateRange,
      "loading-widget-data": _vm.status === 'loading',
      "edit-mode": _vm.editMode,
      "show-close-button": _vm.showCloseButton,
      "show-full-screen-button": _vm.showFullScreenButton,
      "show-edit-mode-button": _vm.showEditModeButton
    },
    on: {
      "update:date-range": function ($event) {
        return _vm.$emit('update:date-range', $event);
      },
      "click:refresh-widget-data": _vm.refreshWidgetData,
      "click:add-widget": function ($event) {
        _vm.showAddWidgetDialog = true;
      },
      "click:parameters": function ($event) {
        _vm.showParametersDialog = true;
      },
      "click:save-default-date-range": function ($event) {
        _vm.showDefaultDateRangeSaveDialog = true;
      },
      "click:breadcrumb-layers": function ($event) {
        return _vm.$emit('click:breadcrumb-layers', $event);
      },
      "update:edit-mode": function ($event) {
        return _vm.$emit('update:edit-mode', $event);
      },
      "close": function ($event) {
        return _vm.$emit('close');
      },
      "click:fullscreen": function ($event) {
        return _vm.$emit('click:fullscreen');
      }
    }
  }), _vm.activeDashboard ? _c('add-widget-dialog', {
    attrs: {
      "dashboard-id": _vm.activeDashboard.id,
      "date-range": _vm.actualDateRange,
      "custom-parameters": _vm.customParameters
    },
    on: {
      "created": function ($event) {
        _vm.showAddWidgetDialog = false;
      }
    },
    model: {
      value: _vm.showAddWidgetDialog,
      callback: function ($$v) {
        _vm.showAddWidgetDialog = $$v;
      },
      expression: "showAddWidgetDialog"
    }
  }) : _vm._e(), _vm.activeDashboard ? _c('dashboard-parameters-dialog', {
    attrs: {
      "dashboard-id": _vm.activeDashboard.id
    },
    on: {
      "close": function ($event) {
        _vm.showParametersDialog = false;
      }
    },
    model: {
      value: _vm.showParametersDialog,
      callback: function ($$v) {
        _vm.showParametersDialog = $$v;
      },
      expression: "showParametersDialog"
    }
  }) : _vm._e(), _c('core-n20-dialog', {
    attrs: {
      "is-open": _vm.showDefaultDateRangeSaveDialog,
      "title": "Save default date range"
    },
    on: {
      "close": _vm.closeDefaultDateRangeSaveDialog
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Dashboards.view.dialog.saveDefaultDateRange.text')))]), _c(VRow, [_c(VCol, {
    attrs: {
      "shrink": ""
    }
  }, [_c(VBtn, {
    attrs: {
      "text": "",
      "color": "error",
      "disabled": _vm.isSavingDefaultDateRange
    },
    on: {
      "click": _vm.closeDefaultDateRangeSaveDialog
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('Dashboards.view.dialog.saveDefaultDateRange.button.cancel')) + "\n        ")])], 1), _c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c('core-button', {
    attrs: {
      "loading": _vm.savingDefaultDateRangeAs === 'absolute',
      "disabled": _vm.isSavingDefaultDateRange
    },
    on: {
      "click": function ($event) {
        return _vm.saveDefaultDateRange(true);
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('Dashboards.view.dialog.saveDefaultDateRange.button.saveAsAbsolute')) + "\n        ")])], 1), _c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c('core-button', {
    attrs: {
      "loading": _vm.savingDefaultDateRangeAs === 'relative',
      "disabled": _vm.isSavingDefaultDateRange
    },
    on: {
      "click": function ($event) {
        return _vm.saveDefaultDateRange(false);
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('Dashboards.view.dialog.saveDefaultDateRange.button.saveAsRelative')) + "\n        ")])], 1)], 1)], 1), _c(VContainer, {
    staticClass: "n20-container pl-4 pr-4 pb-4 pt-2",
    attrs: {
      "fluid": ""
    }
  }, [_vm.status === 'loading' ? _c(VProgressLinear, {
    attrs: {
      "indeterminate": ""
    }
  }) : _vm.status === 'failed' ? _c(VAlert, {
    attrs: {
      "prominent": "",
      "type": "error"
    }
  }, [_c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    staticClass: "grow"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Dashboards.view.error.loadingDashboard')))]), _c('p', [_vm._v(_vm._s(_vm.error))])]), _c(VCol, {
    staticClass: "shrink"
  }, [_c(VBtn, {
    on: {
      "click": function ($event) {
        return _vm.$store.dispatch('dashboards/refresh');
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Dashboards.view.button.retryLoadingDashboard')) + "\n          ")])], 1)], 1)], 1) : _vm._e(), _vm.activeDashboard ? _c('dashboard-widget-grid', {
    ref: "dashboardWidgetGrid",
    attrs: {
      "dashboard": _vm.activeDashboard,
      "edit-mode": _vm.editMode,
      "date-range": _vm.actualDateRange,
      "custom-parameters": _vm.customParameters,
      "widget-min-size": _vm.widgetMinSize
    },
    on: {
      "change:widget-order": function ($event) {
        return _vm.$emit('change:widget-order', $event);
      },
      "activate-sub-dashboard": function ($event) {
        return _vm.$emit('activate-sub-dashboard', $event);
      }
    }
  }) : _vm._e(), _vm.activeDashboard && _vm.activeDashboard.value.widgets.length === 0 ? _c(VCard, [_c(VCardText, [_c('core-empty-state', {
    attrs: {
      "icon": "fal fa-chart-line",
      "color": _vm.color,
      "title": _vm.$t('Dashboards.view.alerts.info.noWidgets.text'),
      "description": _vm.$t('Dashboards.view.alerts.info.noWidgets.description'),
      "button-label": _vm.$t('Dashboards.view.alerts.info.noWidgets.button')
    },
    on: {
      "click:button": function ($event) {
        _vm.showAddWidgetDialog = true;
      }
    }
  })], 1)], 1) : _vm._e()], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };